export default __webpack_public_path__ + "static/media/proposal-default.0b200a95.jpg";